import React, { createContext, useCallback, useContext, useState } from 'react';
import { Dropdown as ReactstrapDropdown } from 'reactstrap';
import cn from 'classnames';
import styles from './index.module.scss';

import DropdownTrigger from './DropdownTrigger';
import DropdownMenu from './DropdownMenu';
import DropdownOption from './DropdownOption';
import DropdownIndicator from './DropdownIndicator';

/**
 * @type {React.Context<{
 *  isOpen: boolean,
 *  disabled: boolean,
 *  onToggle: () => void
 * }>}
 */
export const DropdownContext = createContext();

export const useDropdown = () => useContext(DropdownContext);

/**
 * @param {Object} props
 * @param {boolean} props.defaultOpen
 * @param {boolean} props.disabled
 * @param {string} props.className
 * @param {(e: React.MouseEvent) => void} props.onClick
 * @param {import('utils/types').DropdownDirection} props.direction
 * @param {React.ReactNode} props.children
 */
export default function Dropdown({
  defaultOpen = false,
  disabled = false,
  className = '',
  onClick = () => {},
  direction = 'down',
  children = null
}) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const onToggle = useCallback(() => setIsOpen(open => !open), []);

  return (
    <DropdownContext.Provider value={{ isOpen, disabled, onToggle }}>
      <ReactstrapDropdown
        isOpen={isOpen}
        onClick={onClick}
        direction={direction}
        toggle={onToggle}
        className={cn(styles.container, className)}
      >
        {children}
      </ReactstrapDropdown>
    </DropdownContext.Provider>
  );
}

Dropdown.useDropdown = useDropdown;
Dropdown.Trigger = DropdownTrigger;
Dropdown.Menu = DropdownMenu;
Dropdown.Option = DropdownOption;
Dropdown.Indicator = DropdownIndicator;
